import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  inject,
  signal,
  input,
} from '@angular/core'

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'wm-front-loading-image',
  imports: [MatProgressSpinnerModule, MatIcon],
  templateUrl: './loading-image.component.html',
  styleUrls: ['./loading-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingImageComponent {
  /** The max width of the image */
  @Input() public maxWidth?: string

  /** The max height of the image */
  @Input() public maxHeight?: string

  /** With border and shadow */
  @Input() public withBorderAndShadow = false

  public withErrorText = input(false)

  /** The url of the image currently displayed */
  public currentUrl = ''

  /** If the image is loaded or not */
  public loading = false

  public inErrorState = signal(false)

  private cd = inject(ChangeDetectorRef)

  /**
   * The src to be displayed
   * @param {string} src
   */
  @Input()
  public set src(src: string) {
    this.loading = true
    this.currentUrl = src
    this.cd.markForCheck()
  }

  /**
   * What will happen when the image is loaded
   */
  public onLoaded(): void {
    this.loading = false
    this.cd.markForCheck()
  }

  public onError(): void {
    this.loading = false
    this.inErrorState.set(true)
  }
}
